export enum TermsAndConditionVersions {
    General = 0,
    Affiliate = 1,
    Cards = 2,
}